import { RemoteConstants } from "../../data/remote/RemoteConstants";
import { errorManager } from "../../presentation/utils/errorManager";

export const WhatsappMessageSimple = async (token, params) => {
    try {
        const queryParams = new URLSearchParams({
            token: token,
            number: params.number,
            document: params.document,
            op_id: params.op_id
        });

        const resp = await fetch(`${RemoteConstants.BASE_URL}/send/receipt/by/whatsapp?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(resp => {
                return resp.json();
            })
            .then(data => {
                if (data.code === 'OK') {
                    return data.data;
                } else {
                    errorManager(data.userMessage);
                    throw new Error(data.userMessage);
                }
            });

        return resp;
    } catch (error) {
        console.error('❌ Error consultando deuda:', error);
        errorManager(error.userMessage);
        throw error;
    }
}